import type { WebsiteHeaderPhotoSchema_PageWidth_v1_1_1 } from '@shared/types/WebsiteHeaderSettings.types';

export const PAGE_WIDTH_v1_1_1: WebsiteHeaderPhotoSchema_PageWidth_v1_1_1 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/pageWidth-v1_1_1.json',
  presentationLayout: 'pageWidth',
  photos: [],
};
